import React from 'react';
import PropTyes from 'prop-types';
import { Provider } from 'react-redux';
import store from '../store';
import { AuthContextProvider } from '../contexts/AuthContext';

const ProviderWrapper = ({ children }) => (
  <Provider store={store}>
    <AuthContextProvider>
      {children}
    </AuthContextProvider>
  </Provider>
);

ProviderWrapper.propTypes = {
  children: PropTyes.element.isRequired,
};

export default ProviderWrapper;
